import { render, staticRenderFns } from "./RaceOptions.vue?vue&type=template&id=670e3c7d&scoped=true&"
import script from "./RaceOptions.vue?vue&type=script&lang=js&"
export * from "./RaceOptions.vue?vue&type=script&lang=js&"
import style0 from "./RaceOptions.vue?vue&type=style&index=0&id=670e3c7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e3c7d",
  null
  
)

export default component.exports